// may be removable after moving to next 13
import styled from 'styled-components';
import { cssColorValue } from '@spotify-internal/encore-web';
import React, { PropsWithChildren, useEffect } from 'react';

const Layout = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${cssColorValue('backgroundBase')};
`;

export const HeaderlessLayout = (
  props: PropsWithChildren<{ className?: string }>,
) => {
  useEffect(() => {
    document!
      .querySelector('#__chrome')
      ?.shadowRoot?.querySelector('header')
      ?.setAttribute('style', 'display: none');
  }, []);

  return <Layout className={props.className}>{props.children}</Layout>;
};
